// src/components/DynamicSEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { seoData } from '../seoConfig';

export default function DynamicSEO() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Agar current path config mein hai toh wo use karo, warna 'default' use karo
  const currentSEO = seoData[currentPath] || seoData["default"];

  return (
    <Helmet>
      <title>{currentSEO.title}</title>
      <meta name="description" content={currentSEO.description} />
      <meta name="keywords" content={currentSEO.keywords} />
      
      {/* Tum chaho toh yahan Open Graph (OG) tags bhi add kar sakte ho */}
      <meta property="og:title" content={currentSEO.title} />
      <meta property="og:description" content={currentSEO.description} />
      <meta property="og:url" content={window.location.href} />
    </Helmet>
  );
}